module.exports = __webpack_public_path__ + "media/בן.1481808c.mp3";